import React, { useRef, useState, useEffect } from "react"

// redux
import { useNavigate } from "react-router-dom"
import { ROUTES } from "../../../routes"
import { mapDispatchProps, mapStateToProps } from "../../../store/store"
import { connect } from "react-redux"
import { motion, useMotionValueEvent, useScroll } from "framer-motion"
import { Modal } from "antd"
import axios from "axios"
import { useLanguage } from "@languages/index"
import DOMAIN from "constants/domain"
import { LOCALES } from "constants/locales"

const SnsIntro = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.sns }
  const navigate = useNavigate()
  const [showFloatingButtons, setShowFloatingButtons] = useState(false)
  const [isProgressModalVisible, setIsProgressModalVisible] = useState(false)
  const [isCompleteModalVisible, setIsCompleteModalVisible] = useState(false)
  const [isManagerModalVisible, setIsManagerModalVisible] = useState(false)

  const scrollContainerRef = useRef(null)
  const { scrollY } = useScroll({
    container: scrollContainerRef,
  })

  useMotionValueEvent(scrollY, "change", (latest) => {
    const nextState = latest > 740 ? true : false
    if (showFloatingButtons != nextState) {
      setShowFloatingButtons(nextState)
    }
  })

  const openPDF = () => {
    window.open("https://" + DOMAIN.BASE.URL + "/intro/sns.pdf", "_blank")
  }

  const footerAnimVariants = {
    hidden: { opacity: 0, y: 300 },
    show: { opacity: 1, y: 0 },
  }

  const storeContact = () => {
    const members = props.brand.members.map((member) => {
      return {
        name: member.name,
        role: member.role,
        mobile: member.mobile,
      }
    })

    axios
      .post("https://brand.nmodelin.com/business/contact", {
        name: props.brand.name,
        message: languageTexts.intro_text_1,
        managerName: languageTexts.intro_text_2,
        contact: JSON.stringify(members, undefined, 2),
      })
      .then((response) => {})
      .catch((error) => {
        console.log(error)
        alert(error.message)
      })
  }

  const showLoadingModal = () => {
    setIsProgressModalVisible(true)
  }

  return (
    <div
      ref={scrollContainerRef}
      style={{
        maxHeight: "100dvh",
        overflow: "scroll",
      }}
    >
      <div className="section-1 items-center justify-center w-full h-full flex flex-col py-[80px] mx-auto">
        <div
          className="flex flex-col w-full mx-auto"
          style={{
            paddingTop: props.preferences.headerHeight,
          }}
        >
          <div className="flex flex-col justify-center items-center mb-[17px]">
            <span className="text-[28px] md:text-5xl font-bold">{languageTexts.intro_text_3}</span>
            <span className="text-[#FF0099] text-[28px] md:text-5xl font-bold">{languageTexts.intro_text_4}</span>
          </div>

          <div className="text-center text-stone-500 text-lg font-normal mb-[25px]">{languageTexts.intro_text_5}</div>

          <div className="flex flex-row gap-[5px] mx-auto justify-center">
            <div
              className="w-[149px] h-14 flex flex-1 flex-col justify-center items-center border border-[#E8E8E8] rounded-full md:max-w-[248px] bg-black break-keep max-h-[60px]"
              onClick={() => {
                openPDF()
              }}
            >
              <span className="text-[16px] font-bold text-center py-[18px] text-white">
                {languageTexts.intro_text_6}
              </span>
            </div>
            <div
              className="w-[149px] h-14 bg-orange-500 rounded-[56px] flex justify-center items-center cursor-pointer"
              onClick={() => {
                showLoadingModal()
              }}
            >
              <span className="text-center text-white text-base font-bold">{languageTexts.intro_text_7}</span>
            </div>
          </div>

          <div className="md:max-w-[1024px] w-full px-[28px] pt-[64px] mx-auto">
            <img className="w-full h-full drop-shadow flex md:hidden" src={`/assets/images/sns/sns-intro-01.png`} />
            <img
              className="w-full h-full drop-shadow md:flex hidden"
              src={`/assets/images/sns/sns-intro-01-full.png`}
            />
          </div>
        </div>
      </div>

      <div className="section-2 bg-white items-center justify-center py-[150px]">
        <div className="flex flex-col justify-center items-center w-full mx-auto gap-[150px]">
          <div className="checkpoint-1 flex flex-col w-full">
            <div className="w-full flex flex-row justify-center mb-[15px]">
              <div className="w-[133px] h-9 bg-black rounded-[33px] flex justify-center items-center">
                <span className="text-center text-white text-base font-bold">{languageTexts.intro_text_8}</span>
              </div>
            </div>

            <span className="text-[22px] md:text-[32px] text-[#000] text-center font-bold mb-[14px]">
              {languageTexts.intro_text_9}
            </span>

            <span className="text-[18px] text-[#666] text-center mb-[40px] md:mb-[50px]">
              {languageTexts.intro_text_10}
              <br className="flex md:hidden" />
              {languageTexts.intro_text_11}
            </span>

            <div className="w-full px-[28px] max-w-[413px] mx-auto">
              <img className="w-full h-full" src={`/assets/images/sns/sns-intro-02.svg`} />
            </div>
          </div>

          <div className="checkpoint-2 flex flex-col items-center justify-center w-full">
            <div className="w-full flex flex-row justify-center mb-[15px]">
              <div className="w-[133px] h-9 bg-black rounded-[33px] flex justify-center items-center">
                <span className="text-center text-white text-base font-bold">{languageTexts.intro_text_12}</span>
              </div>
            </div>

            <span className="text-[22px] md:text-[32px] text-[#000] text-center font-bold mb-[14px]">
              {languageTexts.intro_text_13}
              <br />
              {languageTexts.intro_text_14}
            </span>

            <span className="text-[18px] text-[#666] text-center mb-[40px] md:mb-[50px]">
              {languageTexts.intro_text_15}
              <br className="flex md:hidden" />
              {languageTexts.intro_text_16}
            </span>

            <div className="flex flex-col justify-center items-center mb-[30px] md:max-w-[1024px] w-full mx-auto">
              <img className="w-full h-full drop-shadow flex md:hidden" src={`/assets/images/sns/sns-intro-03.png`} />
              <img
                className="w-full h-full drop-shadow md:flex hidden"
                src={`/assets/images/sns/sns-intro-03-full.png`}
              />
            </div>
          </div>

          <div className="checkpoint-3 flex flex-col items-center justify-center w-full">
            <div className="w-full flex flex-row justify-center mb-[15px]">
              <div className="w-[133px] h-9 bg-black rounded-[33px] flex justify-center items-center">
                <span className="text-center text-white text-base font-bold">{languageTexts.intro_text_17}</span>
              </div>
            </div>

            <span className="text-[22px] md:text-[32px] text-[#000] text-center font-bold mb-[14px]">
              {languageTexts._intro_text_18()}
            </span>

            <span className="text-[18px] text-[#666] text-center mb-[40px] md:mb-[50px]">
              {languageTexts._intro_text_19()}
            </span>

            <div className="flex flex-col md:flex-row justify-center items-center w-full mb-[112px]">
              <img className="w-full h-full drop-shadow flex md:hidden" src={`/assets/images/sns/sns-intro-04.png`} />
              <img
                className="w-full h-full drop-shadow md:flex hidden"
                src={`/assets/images/sns/sns-intro-04-full.png`}
              />
            </div>

            <span className="text-[22px] md:text-[32px] text-[#000] text-center font-bold mb-[14px]">
              {languageTexts.intro_text_20}
            </span>

            <span className="text-[18px] text-[#666] text-center mb-[40px] md:mb-[50px]">
              {languageTexts._intro_text_21()}
            </span>

            <div className="flex flex-col md:flex-row justify-center items-center w-full mb-[112px] px-[28px] md:max-w-[1024px] mx-auto">
              <img className="w-full h-full drop-shadow flex md:hidden" src={`/assets/images/sns/sns-intro-05.png`} />
              <img
                className="w-full h-full drop-shadow md:flex hidden"
                src={`/assets/images/sns/sns-intro-05-full.png`}
              />
            </div>

            <span className="text-[22px] md:text-[32px] text-[#000] text-center font-bold mb-[14px]">
              {languageTexts.intro_text_22}
            </span>

            <span className="text-[18px] text-[#666] text-center mb-[40px] md:mb-[50px]">
              {languageTexts._intro_text_23()}
            </span>

            <div className="flex flex-col justify-center items-center mb-[30px] w-full md:max-w-[1024px] mx-auto gap-[2.5px] px-[20px]">
              <img className="w-[60px] h-full flex md:hidden" src={`/assets/images/sns/sns-intro-06.png`} />
              <img className="w-[250px] h-full md:flex hidden" src={`/assets/images/sns/sns-intro-06-full.png`} />
            </div>
          </div>
        </div>
      </div>

      <motion.div
        className="fixed bottom-0 left-0 right-0 md:mb-[40px]"
        variants={footerAnimVariants}
        initial={"hidden"}
        animate={showFloatingButtons ? "show" : "hidden"}
        transition={{ type: "just" }}
      >
        <div className="flex flex-row cursor-pointer mt-[-1px] justify-center items-center border-t border-[#E8E8E8] md:border-0 md:gap-[12px]">
          <div
            className="bg-[#000000] flex flex-1 flex-col justify-center items-center md:rounded-full md:max-w-[248px]  break-keep max-h-[60px]"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              openPDF()
            }}
          >
            <span className="text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px] ">
              {languageTexts.intro_text_6}
            </span>
          </div>
          <div
            className="bg-[#FF0099] flex flex-1 flex-col justify-center items-center md:rounded-full md:max-w-[248px]"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              showLoadingModal()
            }}
          >
            <span className="text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              {languageTexts.intro_text_7}
            </span>
          </div>
        </div>
      </motion.div>

      <ProgressModal
        isProgressModalVisible={isProgressModalVisible}
        onComplete={() => {
          storeContact()
          setIsProgressModalVisible(false)
          setIsCompleteModalVisible(true)
        }}
      />

      <CompleteModal
        isCompleteModalVisible={isCompleteModalVisible}
        onComplete={() => {
          setIsCompleteModalVisible(false)
          setIsManagerModalVisible(true)
        }}
      />

      <ManagerModal
        name={props.brand.name}
        avatar={
          process.env.LOCALE == LOCALES.KO
            ? "/assets/images/manager/manager-mikyeong.png"
            : "/assets/images/manager/manager-momo.png"
        }
        isManagerModalVisible={isManagerModalVisible}
        onOk={() => {
          setIsManagerModalVisible(false)
        }}
      />
    </div>
  )
}

const ProgressModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.sns }
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (props.isProgressModalVisible == false) {
      setProgress(0)
    }

    if (props.isProgressModalVisible) {
      const targetProgress = 100
      const duration = 2000

      const startTime = Date.now()

      const increaseProgress = () => {
        const currentTime = Date.now()
        const elapsedTime = currentTime - startTime

        if (progress < targetProgress && elapsedTime < duration) {
          setProgress(Math.min(targetProgress, (elapsedTime / duration) * targetProgress))
          requestAnimationFrame(increaseProgress)
        } else {
          setProgress(100)
          props.onComplete ? props.onComplete() : null
        }
      }

      increaseProgress()
    }
  }, [props.isProgressModalVisible])

  return (
    <Modal centered={true} open={props.isProgressModalVisible} onOk={props.handleOk} footer={null} closable={false}>
      <div className="text-center text-black text-[17px] font-normal py-[15px]">{languageTexts.intro_text_24}</div>

      <div className="text-center text-black text-lg font-bold">{progress.toFixed(1)}%</div>

      <div className="w-[275px] h-[6px] bg-gray-200 rounded-[32px] relative my-[10px] mx-auto">
        <div
          className="absolute inset-0 h-full bg-orange-500 rounded-[32px]"
          style={{
            width: `${progress.toFixed(1)}%`,
          }}
        />
      </div>
    </Modal>
  )
}

const CompleteModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.sns }
  useEffect(() => {
    if (props.isCompleteModalVisible) {
      setTimeout(() => {
        props.onComplete ? props.onComplete() : null
      }, 1000)
    }
  }, [props.isCompleteModalVisible])

  return (
    <Modal centered={true} open={props.isCompleteModalVisible} footer={null} closable={false}>
      <div className="flex flex-col gap-[16px] items-center">
        <div className="text-center text-black text-[17px] font-normal py-[15px]">{languageTexts.intro_text_25}</div>

        <div className="mx-auto flex justify-center items-center">
          <img src={`/assets/icons/check-orange.svg`} />
        </div>
      </div>
    </Modal>
  )
}

const ManagerModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.sns }
  return (
    <Modal centered={true} open={props.isManagerModalVisible} footer={null} closable={false}>
      <div className="flex flex-col gap-[30px] py-[50px]">
        <div className="flex flex-col justify-center mx-auto items-center gap-[10px]">
          <img src={`${props.avatar}`}></img>
          <div className="text-black text-[17px] font-bold">{languageTexts.intro_text_26}</div>
          {/* <img className="max-w-[58px]" src={`/assets/logo/logo-black-sm.svg`}></img> */}
        </div>
        <div className="text-center text-black text-[17px] font-normal py-[15px]">
          {languageTexts._intro_text_27(props.name)}
        </div>
      </div>

      <div className="w-full flex flex-col pb-[50px]">
        <div
          className="flex justify-center items-center w-[140px] h-12 bg-orange-500 rounded-[41px] mx-auto cursor-pointer"
          onClick={props.onOk ? props.onOk : null}
        >
          <div className="text-center text-white text-[17px] font-bold">{languageTexts.confirm}</div>
        </div>
      </div>
    </Modal>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(SnsIntro)
